import { createRouter, parseSearchWith, stringifySearchWith } from "@tanstack/react-router";
import { decodeFromBinary, encodeToBinary } from "@/lib/encoding";
import { rootRoute } from "./root-route";
import { appRoute } from "./app-route";
import { helpFeedbackRoute, helpHowToRoute, helpRootRoute, helpRoute } from "./help-route";
import { loginRoute } from "./login-route";

const routeTree = rootRoute.addChildren([
  appRoute,
  helpRoute.addChildren([
    helpRootRoute,
    helpHowToRoute,
    helpFeedbackRoute,
  ]),
  loginRoute,
])

export const router = createRouter({
  routeTree,
  parseSearch: parseSearchWith((value) => JSON.parse(decodeFromBinary(value))),
  stringifySearch: stringifySearchWith((value) =>
    encodeToBinary(JSON.stringify(value)),
  ),
  defaultStructuralSharing: true,
})
